<script>
  export let label;
  export let isRequired = false;
</script>

<div class="field">
  <div class="label">{label} {isRequired ? ' *' : ''}</div>
  <div class="control">
    <slot />
  </div>
</div>
